import { createSlice } from '@reduxjs/toolkit';

// Define the initial state using that type
const initialState: IBenchReservationState = {
    data: null,
    racks: null,
    pageSize: 0,
    pageNumber: 0,
    totalCount: 0,
    showLoading: {
        sourceAction: '',
        state: false,
    },
    isLoading: false,
    isSuccess: false,
    details: null
};

export const benchReservationSlice = createSlice({
    name: 'benchReservation',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        setLoading: (state, action) => {
            const { isLoading, isSuccess } = action.payload;
            state.showLoading = {
                sourceAction: action.payload.sourceAction,
                state: true,
            };
            state.isLoading = isLoading ? isLoading : false;
            state.isSuccess = isSuccess ? isSuccess : false;
        },
        resetLoading: (state, action) => {
            const { isLoading, isSuccess } = action.payload;
            state.showLoading = {
                sourceAction: '',
                state: false,
            };
            state.isLoading = isLoading ? isLoading : false;
            state.isSuccess = isSuccess ? isSuccess : false;
        },
        replaceBenchReservation: (state, action) => {
            const { data, pageSize, pageNumber, totalCount, details } = action.payload;
            state.data = data;
            state.details = details;
            state.pageSize = pageSize;
            state.pageNumber = pageNumber;
            state.totalCount = totalCount;
        },
        replaceRacks: (state, action) => {
            const { data, pageSize, pageNumber, totalCount } = action.payload;
            state.racks = data;
            state.pageSize = pageSize;
            state.pageNumber = pageNumber;
            state.totalCount = totalCount;
        },
        addBenchReservation: (state, action) => {
            const newItem = action.payload.data;
            if (state.data && state.data.length > state.pageSize) {
                state.data.pop();
            }
            state.data = state.data ? [newItem, ...state.data] : [newItem];
            state.totalCount = state.totalCount + 1;
        },
        updateBenchReservation: (state, action) => {
            const { localID, data } = action.payload;
            if (localID !== undefined && localID >= 0 && state.data) {
                state.data[localID] = data;
            }
            state.details = data;
        },
        deleteBenchReservation: (state, action) => {
            const benchReservationToRemove: IBenchReservation= action.payload.data;
            const newBenchReservationData = state.data && state.data.filter(
                (benchReservation: IBenchReservation) => {
                    return (
                        benchReservation.id !== benchReservationToRemove.id
                    );
                }
            );
            state.data = newBenchReservationData;
            state.totalCount = state.totalCount - 1;
        },
        setBenchReservationDetails: (state, action) => {
            state.details = action.payload.data;
        },
        resetBenchReservationDetails: (state) => {
            state.details = null;
        },
        setRacks: (state, action) => {
            state.racks = action.payload.data;
        }
    },
});

export const benchReservationActions = benchReservationSlice.actions;

export default benchReservationSlice.reducer;
